var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24831_12558)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1377 2.65527C8.13773 2.4599 8.3741 2.3644 8.51172 2.50586L10.4912 4.52441C10.5768 4.61264 10.5745 4.74934 10.4863 4.83496L8.46777 6.48633C8.32598 6.62399 8.09188 6.52161 8.09473 6.3291L8.1084 5.03906C7.82117 5.02169 7.532 5.03893 7.24805 5.09082C6.22326 5.28311 5.33772 5.93506 4.83398 6.8252C4.22519 7.92004 4.24379 9.27423 4.89941 10.3525C4.91564 10.3799 4.92836 10.4084 4.93848 10.4375C5.59051 11.4554 6.75529 12.1205 8.08496 12.0547C9.37537 11.9906 10.5177 11.1643 11.0771 9.99707C11.3861 9.34649 11.4565 8.72533 11.3848 8.1377C11.3644 7.99624 11.4144 7.84859 11.5195 7.75195C11.7846 7.5127 12.2136 7.6672 12.2559 8.02051C12.332 8.6083 12.2878 9.23069 12.085 9.86816C11.5569 11.5381 10.0449 12.7709 8.29785 12.9209C5.33782 13.1773 2.97986 10.5368 3.60547 7.59668C3.73227 7.00283 3.98543 6.45413 4.33105 5.97656C4.35351 5.94525 4.37701 5.91463 4.40039 5.88379C4.43423 5.83953 4.46746 5.79487 4.50293 5.75195C4.60786 5.62399 4.72124 5.50082 4.84277 5.38281C5.75339 4.49872 6.94901 4.09641 8.12207 4.15723L8.1377 2.65527Z",
    fill: "#C13245"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24831_12558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishIcon);
export default __webpack_public_path__ + "static/media/publish-icon.8e44a9e6.svg";
export { ForwardRef as ReactComponent };